import { useState } from "react";

export default function AdmissionForm() {
  const [formData, setFormData] = useState({
    studentName: "",
    age: "",
    parentName: "",
    mobile: "",
    email: "",
    experience: "Beginner",
    address: "",
    batch: "Morning Batch",
    role: "Batsman",
  });

  const [submitting, setSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  // Google Apps Script Web App URL
  const GOOGLE_SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycbzynYix0pm90I2vlEjOsK_w1ECYxbZ4D0ONJim7HnXVFEuh9jcq-vTQms1BmAKNCTff/exec";

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitting(true);
    setSubmitMessage("");

    try {
      // Send enquiry to Google Sheets
      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "text/plain;charset=utf-8",
        },
      });

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.error || "Failed to save enquiry");
      }

      // WhatsApp message
      const message = `
🏏 New Admission Enquiry

👤 Student Name: ${formData.studentName}
🎂 Age: ${formData.age}
👨 Parent Name: ${formData.parentName}
📱 Mobile: ${formData.mobile}
📧 Email: ${formData.email}

🏏 Experience: ${formData.experience}
🕒 Preferred Batch: ${formData.batch}
🎯 Playing Role: ${formData.role}

📍 Address:
${formData.address}
      `;

      const whatsappURL =
        `https://wa.me/919790964195?text=${encodeURIComponent(message)}`;

      // Open WhatsApp
      window.open(whatsappURL, "_blank");

      // Clear form
      setFormData({
        studentName: "",
        age: "",
        parentName: "",
        mobile: "",
        email: "",
        experience: "Beginner",
        address: "",
        batch: "Morning Batch",
        role: "Batsman",
      });

      setSubmitMessage("✅ Enquiry submitted successfully!");

    } catch (error) {
      console.error("Submission error:", error);

      setSubmitMessage(
        "❌ Unable to submit enquiry. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section
      id="admission"
      className="py-20 px-6 bg-gradient-to-b from-black to-gray-900 text-white"
    >
      <div className="max-w-4xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#D4AF37]">
            Admission Form
          </h2>

          <p className="mt-4 text-gray-300 max-w-2xl mx-auto">
            Join Hunters Cricket Club & Academy and begin your professional
            cricket journey with expert coaching and match exposure.
          </p>
        </div>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="bg-white/10 backdrop-blur-md border border-white/10 rounded-3xl p-8 shadow-2xl grid grid-cols-1 md:grid-cols-2 gap-6"
        >

          {/* Student Name */}
          <div>
            <label className="block mb-2 font-semibold text-[#D4AF37]">
              Student Name
            </label>

            <input
              type="text"
              name="studentName"
              value={formData.studentName}
              onChange={handleChange}
              placeholder="Enter student name"
              required
              className="w-full p-4 rounded-xl bg-black/30 border border-white/10 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
            />
          </div>

          {/* Age */}
          <div>
            <label className="block mb-2 font-semibold text-[#D4AF37]">
              Age
            </label>

            <input
              type="number"
              name="age"
              value={formData.age}
              onChange={handleChange}
              placeholder="Enter age"
              required
              min="1"
              max="100"
              className="w-full p-4 rounded-xl bg-black/30 border border-white/10 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
            />
          </div>

          {/* Parent Name */}
          <div>
            <label className="block mb-2 font-semibold text-[#D4AF37]">
              Parent Name
            </label>

            <input
              type="text"
              name="parentName"
              value={formData.parentName}
              onChange={handleChange}
              placeholder="Enter parent name"
              className="w-full p-4 rounded-xl bg-black/30 border border-white/10 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
            />
          </div>

          {/* Mobile Number */}
          <div>
            <label className="block mb-2 font-semibold text-[#D4AF37]">
              Mobile Number
            </label>

            <input
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Enter mobile number"
              required
              className="w-full p-4 rounded-xl bg-black/30 border border-white/10 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block mb-2 font-semibold text-[#D4AF37]">
              Email Address
            </label>

            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email address"
              className="w-full p-4 rounded-xl bg-black/30 border border-white/10 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
            />
          </div>

          {/* Experience */}
          <div>
            <label className="block mb-2 font-semibold text-[#D4AF37]">
              Cricket Experience
            </label>

            <select
              name="experience"
              value={formData.experience}
              onChange={handleChange}
              className="w-full p-4 rounded-xl bg-black/30 border border-white/10 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
            >
              <option className="text-black">Beginner</option>
              <option className="text-black">Intermediate</option>
              <option className="text-black">Advanced</option>
            </select>
          </div>

          {/* Address */}
          <div className="md:col-span-2">
            <label className="block mb-2 font-semibold text-[#D4AF37]">
              Address
            </label>

            <textarea
              rows="4"
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="Enter address"
              className="w-full p-4 rounded-xl bg-black/30 border border-white/10 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
            ></textarea>
          </div>

          {/* Preferred Batch */}
          <div>
            <label className="block mb-2 font-semibold text-[#D4AF37]">
              Preferred Batch
            </label>

            <select
              name="batch"
              value={formData.batch}
              onChange={handleChange}
              className="w-full p-4 rounded-xl bg-black/30 border border-white/10 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
            >
              <option className="text-black">Morning Batch</option>
              <option className="text-black">Evening Batch</option>
              <option className="text-black">Weekend Batch</option>
            </select>
          </div>

          {/* Role */}
          <div>
            <label className="block mb-2 font-semibold text-[#D4AF37]">
              Playing Role
            </label>

            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              className="w-full p-4 rounded-xl bg-black/30 border border-white/10 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
            >
              <option className="text-black">Batsman</option>
              <option className="text-black">Bowler</option>
              <option className="text-black">All Rounder</option>
              <option className="text-black">Wicket Keeper</option>
            </select>
          </div>

          {/* Submit Button */}
          <div className="md:col-span-2 text-center mt-4">

            <button
              type="submit"
              disabled={submitting}
              className="bg-[#D4AF37] text-black px-10 py-4 rounded-2xl font-bold text-lg hover:scale-105 hover:shadow-2xl transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {submitting
                ? "Submitting..."
                : "Submit Admission Form"}
            </button>

            {/* Success / Error Message */}
            {submitMessage && (
              <p className="mt-4 font-semibold text-white">
                {submitMessage}
              </p>
            )}

          </div>

        </form>
      </div>
    </section>
  );
}
